






import { getWxLoginAccess } from "@/api/login";
import { _isMobile, getQueryString } from "@/libs/tools";
import { Component, Vue } from "vue-property-decorator";
import { State, Mutation } from "vuex-class";
import { isEmpty, isNotEmpty, isLegalPhoneNumber } from "@/libs/tools";
import { PointParamsD } from "@/Module/pointParams";
import { Points } from "@/Module/point";
import { getPoint } from "@/api/seller";

@Component
export default class WxLogin extends Vue {
    private user: any = {};
    private pointParams: PointParamsD = {
        pageType: 2,
        pageKey: Points[""],
        source: "",
        productId: 0
    };
    @State("bind") stateBind: any;

    mounted() {
        let code: any = getQueryString("code"); // 临时授权码
        this.pointParams.pageType = _isMobile() ? 1 : 2;
        this.getUserInfo(code);
    }
    getUserInfo(code: any) {
        getWxLoginAccess(code).then(res => {
            // @ts-ignore
            if (res.code === 200) {
                localStorage.setItem("user", JSON.stringify(res.data));
                localStorage.setItem("refreshToken", res.data.refreshToken);
                localStorage.setItem("accessToken", res.data.accessToken);
                localStorage.setItem("secret", res.data.secret);
                const path = localStorage.getItem("toPath") || "/";

                if (localStorage.getItem("user")) {
                    this.user = JSON.parse(localStorage.getItem("user"));
                    this.$store.state.bind.bind.userId = this.user.userId;
                    if (this.user.needSetPhone) {
                        window.location.href = "/login?needBind=bindTel";
                    } else {
                        window.location.href = path;
                    }
                }
                this.handlePoint("LOGIN_SUCCESS");
            } else {
                // @ts-ignore
                this.$message.error(res.msg);
                this.$router.push("/login?status=login");
            }
        });
    }
    handlePoint(key) {
        this.pointParams.pageKey = Points[key];
        getPoint(this.pointParams);
    }
}
